/**
 * Demo Content
 */
function DemoContent() {
	return (
		<div className="flex-auto p-24">
			<div className="w-full h-7xl min-h-7xl border-2 border-dashed rounded-lg" />
		</div>
	);
}

export default DemoContent;
